"use client";

import React from "react";

import Section from "@/components/common/Section/Section";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";

export type OurNetworkData = {
  image: string;
  heading: string;
  body: string;
};

type OurNetworkProps = {
  data: OurNetworkData;
};

export default function OurNetwork({ data }: OurNetworkProps) {
  return (
    <Section maxWidth={1520} px="px-6" py="pb-[49px] pt-0 md:pb-[65px] lg:pb-[113px]">
      <div className="mx-auto text-center">
        <TextElementNova element="h2" text={data.heading} className="Title-20-Super-Italic mb-2" />
        <TextElementNova element="p" text={data.body} className="Body-30-Dia-Normal" />
      </div>

      <div className="mt-[38px] h-[249px] w-full rounded-lg bg-nova-base-solid-10 md:mt-10 md:h-[344px] lg:mt-16 lg:h-[564px]">
        <div
          className="h-full bg-contain bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${data.image})` }}
          role="presentation"
        />
      </div>
    </Section>
  );
}
